import { SurveyData } from '../generated-api';

export function getFunctionPromisScore(
  survey: SurveyData,
  program: string,
): number {
  if (program.toLowerCase() === 'shoulder') {
    return survey.promisScores.upperExtremityPhysicalFunction || NaN;
  } else {
    return survey.promisScores.physicalFunction || NaN;
  }
}
